export default __webpack_public_path__ + "static/media/E4F8ED9B-F0D1-4C4A-8B99-1A03C7B45E01_1_105_c.7bb3c65e.jpeg";